import { AppointmentLimitReachedModelBase } from "./AppointmentLimitReachedModel.base"


/* A graphql query fragment builders for AppointmentLimitReachedModel */
export { selectFromAppointmentLimitReached, appointmentLimitReachedModelPrimitives, AppointmentLimitReachedModelSelector } from "./AppointmentLimitReachedModel.base"

/**
 * AppointmentLimitReachedModel
 */
export const AppointmentLimitReachedModel = AppointmentLimitReachedModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self))
    }
  }))
